export const palette = {
  id: 'trickOrTreat',
  displayName: 'Trick or Treat',
  graph: {
    writeSample: '#F47B20', writeTrend: 'rgba(244, 123, 32, 0.67)',
    writeMax: '#FFB15E', writeMin: '#B84E06', writeLatency: '#F47B20',
    readSample: '#B28BFF', readTrend: 'rgba(178, 139, 255, 0.67)',
    readMax: '#D5C0FF', readMin: '#7A55C8', readLatency: '#B28BFF',
  },
  canvas: {
    chartBg: '#12091F', gridColor: '#3C2757', textColor: '#EBDCFD',
  },
};

const trickOrTreat = {
  id: 'trickOrTreat',
  displayName: 'Trick or Treat',
  baseType: 'dark',
  enabled: false,
  linkedPalette: 'trickOrTreat',
  palette,
  ui: {
    headerBg: '#12091F', headerText: '#EBDCFD', accentColor: '#F47B20',
    mainBg: '#1B0E2B', mainText: '#EBDCFD', mainTextHeading: '#EBDCFD',
    mainHeroText: '#EBDCFD', footerBg: '#12091F', footerText: '#EBDCFD',
    cardBg: '#261139', cardText: '#EBDCFD', cardBorder: '#5A3B7E',
    cardButtonBg: '#F47B20', cardButtonText: '#FFFFFF',
    navLinkText: '#EBDCFD', navLinkHover: '#F47B20', navLinkActive: '#F47B20',
    listGroupBg: '#261139', bmrkDetailBg: '#12091F',
    bmrkMetricBg: '#261139', bmrkMetricText: '#EBDCFD', bmrkMetricBorder: '#5A3B7E',
    mainCardText: '#EBDCFD', navLinkFocus: '#EBDCFD', navEmailActive: '#EBDCFD',
    homeProseLabel: '#F47B20', homeProseLink: '#B28BFF', homeProseDlBtn: '#B28BFF',
    cardButtonBorder: '#5A3B7E', linkColor: '#F47B20', cardTextMuted: '#B8A5D4',
    cardHeaderBg: '#12091F', cardHeaderText: '#F47B20',
  },
};
export default trickOrTreat;
